import '../styles/main.scss';

import { h } from 'preact';
import { Router } from 'preact-router';

import Home from './home';
import { CheckRegister, Register } from './register';
import Results from './results';

const App = () => (
  <div id="app">
    <Router>
      <Home path="/" />
     {/* <Register path="/register" />*/}
      <CheckRegister path="/checksubmission" />
      <Results path="/results" />
    </Router>
  </div>
);

export default App;
